import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import {
  Card,
  Grid,
  TextField,
} from "@mui/material";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import { Navigate } from "react-router-dom"; // ✅ ADD THIS

const fd = new FormData();

export default class AddAboutUs extends Component {
  state = {
    title: "",
    description: "",
    notification: false,
    message: "",
    redirect: false, // ✅ already present
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleDescription = (content) => {
    this.setState({ description: content });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    fd.append("title", this.state.title);
    fd.append("description", this.state.description);

    if (init() === "success") {
      axios
        .post(Constants.postUrls.createAboutUs, fd)
        .then(() => {
          this.setState({
            notification: true,
            message: "About Us added successfully!",
          });

          // ✅ REDIRECT AFTER SUCCESS
          setTimeout(() => {
            this.setState({
              notification: false,
              message: "",
              redirect: true,
            });
          }, 2000);
        })
        .catch((err) => {
          console.log(err);

          this.setState({
            notification: true,
            message: err?.response?.data?.message || "Something went wrong",
          });

          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    }
  };

  render() {
    // ✅ HANDLE REDIRECT
    if (this.state.redirect) {
      return <Navigate to="/aboutus" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Create About Us
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleInput}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <SunEditor
                      setDefaultStyle="font-family: Arial; font-size: 16px;"
                      setOptions={{
                        height: 200,
                        buttonList: [
                          ["bold", "italic", "underline"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list"],
                          ["link"],
                          ["removeFormat"],
                        ],
                      }}
                      setContents={this.state.description}
                      onChange={this.handleDescription}
                    />
                  </Grid>
                </Grid>

                <MDBox mt={2}>
                  <MDButton variant="contained" color="info" type="submit">
                    Create
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              icon="notifications"
              title="About Us"
              content={this.state.message}
              open={this.state.notification}
              dateTime="Just now"
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
